export const TAG_VARIANTS = {
  DEFAULT: "default",
  TINTED: "tinted",
} as const;

export const TAG_SIZES = {
  EXTRA_SMALL: "extra-small",
  SMALL: "small",
  LARGE: "large",
} as const;
